import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
export const minHeights = {
    LARGE: { sm: 480, lg: 714 },
};
const useStyles = makeStyles()((theme, _params, classes) => {
    const textColor = theme.isFlyingFlowers ? colors.black[700] : colors.supplementary.black;
    return {
        container: {
            position: 'relative',
            minHeight: '100vh',
            overflow: 'hidden',
        },
        backgroundImageContainer: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
        },
        backgroundImage: {
            objectFit: 'cover',
            objectPosition: 'center',
        },
        contentOverlay: {
            position: 'relative',
            zIndex: 2,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        },
        introTextContainer: {
            marginBottom: spacing.small,
        },
        contentOverlayInner: {
            height: '100%',
            display: 'flex',
            boxShadow: 'none',
            [theme.breakpoints.up('sm')]: {
                margin: spacing.medium,
                boxShadow: _params.quizStarted
                    ? 'none'
                    : '0 12px 12px 0 rgba(0, 0, 0, 0.36), 0 16px 48px 0 rgba(0, 0, 0, 0.24)',
            },
            [theme.breakpoints.up('md')]: {
                margin: '123px',
                boxShadow: _params.quizStarted
                    ? 'none'
                    : '0 12px 12px 0 rgba(0, 0, 0, 0.36), 0 16px 48px 0 rgba(0, 0, 0, 0.24)',
            },
        },
        contentContainer: {
            maxWidth: '669px',
            minWidth: '669px',
            color: colors.supplementary.black,
            padding: _params.quizStarted && !_params.showNewsletterForm ? 0 : spacing.xl,
            [theme.breakpoints.down('md')]: {
                maxWidth: '100%',
                minWidth: '100%',
            },
        },
        introTitle: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xxxl : theme.typography.xxl_bold)), { color: textColor, marginBottom: spacing.small, fontSize: theme.isFlyingFlowers ? '3.5rem' : spacing.xl, [theme.breakpoints.down('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.none), { marginBottom: spacing.medium }) }),
        introText: {
            'p&,div&,& ul, & ol': Object.assign(Object.assign({}, theme.typography.small_regular), { color: textColor, marginBottom: spacing.medium, '& ul, & ol': {
                    listStyleType: 'disc',
                    listStylePosition: 'initial',
                }, '&:last-child': {
                    marginBottom: 0,
                } }),
        },
        introTextCollapsed: {
            [theme.breakpoints.down('md')]: {
                display: '-webkit-box',
                '-webkit-line-clamp': 3,
                '-webkit-box-orient': 'vertical',
                overflow: 'hidden',
                marginBottom: spacing.small,
            },
        },
        readMoreLink: Object.assign(Object.assign({ display: 'inline-flex', justifyContent: 'flex-end', width: '100%' }, theme.typography.xxs_regular), { marginBottom: `${spacing.small} !important`, position: 'relative', zIndex: 4, color: textColor, [theme.breakpoints.down('md')]: {
                position: 'sticky',
                bottom: 0,
            }, '& :last-child': {
                paddingLeft: 0,
                transform: 'rotate(45deg)',
                color: textColor,
            } }),
        readLessLink: Object.assign(Object.assign({ display: 'flex', justifyContent: 'flex-end', width: '100%' }, theme.typography.xxs_regular), { marginBottom: spacing.medium, position: 'relative', zIndex: 4, color: textColor, '& :last-child': {
                paddingLeft: 0,
                transform: 'rotate(135deg) !important', // to override default rotation
                color: textColor,
            } }),
        startButton: {
            padding: `${spacing.medium} ${spacing.xl}`,
            minWidth: '300px',
            [theme.breakpoints.down('md')]: {
                width: '100%',
                minWidth: '300px',
            },
            '& span': {
                padding: theme.isFlyingFlowers ? undefined : '0 !important', // to override default button padding
            },
        },
        image: {
            '& img': {
                objectFit: 'cover',
                objectPosition: 'bottom',
            },
        },
        // // Mobile-specific styles
        mobileContainer: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            padding: _params.showNewsletterForm ? `${spacing.medium} 20px 20px 20px` : 0,
        },
        mobileContent: {
            padding: _params.isExpanded ? '0px !important' : `${spacing.medium} ${spacing.medium} 0 ${spacing.medium}`,
            zIndex: 2,
            flexShrink: 0,
        },
        mobileIntroTitle: Object.assign(Object.assign({}, theme.typography.medium_bold), { color: colors.black[700] }),
        mobileOverlayTitle: Object.assign(Object.assign({}, theme.typography.medium_bold), { color: colors.black[700], flexShrink: 1, marginBottom: _params.isExpanded && theme.isFlyingFlowers ? spacing.small : '40px' }),
        mobileIntroText: {
            'p&,div&,& ul, & ol': Object.assign(Object.assign({}, theme.typography.small_regular), { color: textColor, marginBottom: spacing.small, '& ul, & ol': {
                    listStyleType: 'disc',
                    listStylePosition: 'initial',
                }, '&:last-child': {
                    marginBottom: 0,
                } }),
        },
        mobileImageContainer: {
            flex: 1,
            minHeight: 0,
            position: 'relative',
            overflow: 'hidden',
        },
        mobileExpandedOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 3,
            display: 'flex',
            flexDirection: 'column',
            padding: spacing.medium,
            paddingBottom: '100px', // Space for button + gap
            overflow: 'hidden',
        },
        mobileOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: spacing.large,
            opacity: 0,
            visibility: 'hidden',
            transition: 'opacity 0.3s ease, visibility 0.3s ease',
            pointerEvents: 'none',
        },
        mobileOverlayVisible: {
            opacity: 1,
            visibility: 'visible',
            pointerEvents: 'auto',
            position: 'absolute',
            top: 0,
            height: 'calc(100% - 260px)',
            width: '100%',
        },
        mobileOverlayContent: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            overflow: 'visible',
            flexShrink: 0,
        },
        mobileOverlayText: {
            '& p': Object.assign(Object.assign({}, theme.typography.medium_regular), { color: colors.supplementary.white, lineHeight: 1.6, marginBottom: spacing.medium, textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)' }),
        },
        mobileReadMoreButton: {
            color: colors.supplementary.black,
            padding: `${spacing.small} ${spacing.medium}`,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '20px',
            fontSize: '14px',
            fontWeight: 'normal',
            alignSelf: 'flex-end',
            textDecoration: 'none',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
                textDecoration: 'none',
            },
        },
        mobileStartButton: {
            alignSelf: 'center',
            minWidth: '200px',
            padding: `${spacing.medium} ${spacing.large}`,
            fontSize: '16px',
            fontWeight: 'bold',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(0, 0, 0, 0.5)',
            },
        },
        minHeightLarge: {
            minHeight: minHeights.LARGE.sm,
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.LARGE.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.LARGE.lg,
                maxHeight: minHeights.LARGE.lg,
            },
            '& .image': {
                minHeight: minHeights.LARGE.sm,
                [theme.breakpoints.up('md')]: {
                    minHeight: minHeights.LARGE.sm,
                },
                [theme.breakpoints.up('lg')]: {
                    minHeight: minHeights.LARGE.lg,
                    maxHeight: minHeights.LARGE.lg,
                },
            },
        },
        mobileButtonContainer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: spacing.medium,
            zIndex: 4,
            '& button': {
                width: '100%',
            },
        },
        addMarginToTitle: {
            marginBottom: '40px',
        },
        mobileExpandedContainer: {
            overflow: 'hidden',
            flexShrink: 1,
        },
    };
});
export default useStyles;
